import Box from 'components/shared/Box'
import { useResolutions } from 'store/resolutions'

import { useMemo } from 'react'
import { Badge } from 'store/api-slice/hooks'
import { RoomTileBadge } from './styles'

interface RoomTileBadgesProps {
    badgesData: Badge[]
}

const RoomTileBadges = ({ badgesData }: RoomTileBadgesProps) => {
    const { isTablet } = useResolutions()

    const badgesPills = useMemo(() => {
        if (!badgesData.length) return null

        return badgesData.map(({ text, textColor, backgroundColor }) => (
            <RoomTileBadge
                variant="bodySmall"
                textColor={textColor}
                backgroundColor={backgroundColor}
                key={text}
            >
                {text}
            </RoomTileBadge>
        ))
    }, [badgesData])

    return (
        <Box direction="row" wrap="wrap" gap={4} isFullWidth={isTablet} mt={10}>
            {badgesPills}
        </Box>
    )
}

export default RoomTileBadges
